export default __webpack_public_path__ + "static/media/tømrervinkel.2569ec70.svg";